import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { getInitialize } from "@/redux/slices/auth";
import { getIsAuthenticated } from "@/redux/slices/authSelector";
import Loader from "@/components/Loader";
// 토큰 정보에 대한 조기화가 이루어짐, 새로운 브라우저를 열거나, 새로고침을 누르거나 할때----------------------------------------------------------------------

const JwtProvider = ({ children }: { children: React.ReactElement }) => {
	const dispatch = useDispatch();
	const history = useHistory();
	const isAuthenticated = useSelector(getIsAuthenticated);

	React.useEffect(() => {
		if (history) {
			dispatch(getInitialize(history));
		}
	}, [dispatch]);

	if (isAuthenticated === null) {
		return <Loader fixed />;
	}

	return <>{children}</>;
};

export { JwtProvider };
